import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "isDisabled", "value", "onChange", "description"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import CheckboxOption from 'components/CheckboxOption';
function ExcludeFromAIField(_ref) {
  var id = _ref.id,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    value = _ref.value,
    _onChange = _ref.onChange,
    description = _ref.description,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('actions_exclude_from_ai'),
    labelId: uniqueId,
    description: description
  }, otherProps), /*#__PURE__*/React.createElement(CheckboxOption, {
    fontSize: "s",
    label: t('actions_exclude_content_from_ai_coach'),
    id: "exclude_from_ai",
    checked: value,
    disabled: isDisabled,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    }
  }));
}
export default ExcludeFromAIField;